import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { errMsg } from "@finance/lib/api";
import { CheckCircle, Warning } from "@phosphor-icons/react";

const BASE = process.env.REACT_APP_BACKEND_URL;

const CSS = `
@import url('https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,400;0,500;0,600;0,700;1,400&display=swap');
.lynx-login{--ink:#12151A;--orange:#1B4383;--orange-dark:#122E5C;--teal:#122E5C;--white:#FFFFFF;--steel:#5E6570;--line:#E6E4DF;font-family:'IBM Plex Sans',sans-serif;color:var(--ink);-webkit-font-smoothing:antialiased;}
.lynx-login *{box-sizing:border-box;}
.lynx-login .scene{position:relative;min-height:100vh;width:100%;display:flex;align-items:center;background:linear-gradient(100deg,rgba(10,12,14,0.72) 0%,rgba(10,12,14,0.38) 42%,rgba(10,12,14,0.05) 62%,rgba(10,12,14,0.15) 100%),linear-gradient(0deg,rgba(6,7,8,0.55) 0%,rgba(6,7,8,0) 32%),url('https://images.unsplash.com/photo-1582280871722-424e91cbee8b?fm=jpg&q=80&w=2400&auto=format&fit=crop') center/cover no-repeat;}
.lynx-login .mark{height:52px;width:auto;display:block;object-fit:contain;}
.lynx-login .topleft{position:absolute;top:56px;left:56px;z-index:2;max-width:640px;}
.lynx-login .topleft .mark{margin-bottom:22px;}
.lynx-login .topleft h1{font-weight:700;text-transform:uppercase;font-size:44px;line-height:1.08;letter-spacing:0.005em;color:var(--white);margin:0 0 16px;}
.lynx-login .eyebrow{font-size:13px;font-weight:500;letter-spacing:0.14em;text-transform:uppercase;color:#D8D5CD;}
.lynx-login .eyebrow span{margin:0 10px;color:var(--orange);}
.lynx-login .bottomleft{position:absolute;left:56px;bottom:56px;z-index:2;max-width:620px;}
.lynx-login .bottomleft h2{font-weight:700;text-transform:uppercase;font-size:32px;line-height:1.14;color:var(--white);margin:0 0 10px;}
.lynx-login .bottomleft p{font-style:italic;font-weight:400;font-size:18px;color:#C8CBCE;margin:0;}
.lynx-login .stage{position:relative;z-index:2;margin-left:auto;padding-right:9vw;}
.lynx-login .card{width:356px;background:var(--white);border-radius:10px;padding:36px 32px 28px;text-align:center;box-shadow:0 30px 70px -18px rgba(0,0,0,0.5);}
.lynx-login .card .mark{margin:0 auto 20px;height:44px;}
.lynx-login .card h2{font-size:22px;font-weight:700;margin:0 0 6px;color:var(--ink);}
.lynx-login .card>p{font-size:13.5px;color:var(--steel);margin:0 0 26px;}
.lynx-login .lg-err{margin:0 0 18px;border:1px solid #FBD5D5;background:#FDECEC;color:#B42318;border-radius:6px;padding:10px 12px;font-size:13px;text-align:left;}
.lynx-login .lg-note{border-radius:8px;padding:18px 16px;font-size:13.5px;text-align:left;line-height:1.5;}
.lynx-login .lg-note.err{border:1px solid #FBD5D5;background:#FDECEC;color:#B42318;}
.lynx-login .lg-note.ok{border:1px solid #BBE7CB;background:#EAF7EF;color:#12653A;}
.lynx-login .lg-note .title{font-weight:700;font-size:15px;margin:6px 0 4px;}
.lynx-login .field{margin-bottom:16px;text-align:left;}
.lynx-login label{display:block;font-size:11px;font-weight:600;letter-spacing:0.08em;text-transform:uppercase;color:var(--steel);margin-bottom:7px;}
.lynx-login .field-shell{border:1px solid var(--line);border-radius:6px;background:var(--white);display:flex;align-items:center;transition:border-color .15s ease;}
.lynx-login .field-shell:focus-within{border-color:var(--orange);}
.lynx-login input{width:100%;border:none;background:transparent;padding:12px 13px;font-family:'IBM Plex Sans',sans-serif;font-size:14px;color:var(--ink);border-radius:6px;}
.lynx-login input:focus{outline:none;}
.lynx-login input::placeholder{color:#AEB0AA;}
.lynx-login .toggle-pw{background:none;border:none;cursor:pointer;padding:0 13px;font-family:'IBM Plex Sans',sans-serif;font-size:11px;color:var(--steel);white-space:nowrap;}
.lynx-login .toggle-pw:hover{color:var(--ink);}
.lynx-login button.submit{width:100%;padding:13px 18px;background:var(--orange);color:var(--white);border:none;border-radius:6px;font-family:'IBM Plex Sans',sans-serif;font-size:14.5px;font-weight:600;cursor:pointer;transition:background .15s ease;margin-top:6px;}
.lynx-login button.submit:hover{background:var(--orange-dark);}
.lynx-login button.submit:disabled{opacity:.7;cursor:default;}
.lynx-login button.ghost{margin-top:16px;width:100%;padding:11px 16px;background:transparent;color:var(--ink);border:1px solid var(--line);border-radius:6px;font-family:'IBM Plex Sans',sans-serif;font-size:13.5px;font-weight:600;cursor:pointer;}
.lynx-login button.ghost:hover{border-color:var(--ink);}
.lynx-login .authorized{margin-top:16px;font-size:11.5px;color:#A6A9A4;}
@media (max-width:900px){
.lynx-login .scene{flex-direction:column;justify-content:flex-end;background:linear-gradient(180deg,rgba(10,12,14,0.35) 0%,rgba(10,12,14,0.5) 45%,rgba(10,12,14,0.92) 82%,rgba(10,12,14,0.97) 100%),url('https://images.unsplash.com/photo-1582280871722-424e91cbee8b?fm=jpg&q=80&w=1400&auto=format&fit=crop') center/cover no-repeat;}
.lynx-login .topleft{position:static;padding:40px 24px 0;max-width:none;}
.lynx-login .topleft h1{font-size:30px;}
.lynx-login .bottomleft{position:static;padding:0 24px;margin-top:26px;}
.lynx-login .bottomleft h2{font-size:22px;}
.lynx-login .stage{margin:0;padding:28px 20px 40px;display:flex;justify-content:center;width:100%;}
.lynx-login .card{width:100%;max-width:380px;}
}
`;

export default function ResetPassword() {
  const navigate = useNavigate();
  const token = new URLSearchParams(window.location.search).get("token") || "";
  const [state, setState] = useState("checking"); // checking | invalid | form | done
  const [info, setInfo] = useState(null);
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (!token) { setState("invalid"); return; }
    axios.get(`${BASE}/api/finance/auth/reset-password/validate`, { params: { token } })
      .then((r) => { if (r.data?.valid) { setInfo(r.data); setState("form"); } else setState("invalid"); })
      .catch(() => setState("invalid"));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Choose a password with at least 8 characters."); return; }
    if (pw !== pw2) { setError("The two passwords don't match."); return; }
    setBusy(true);
    try {
      await axios.post(`${BASE}/api/finance/auth/reset-password`, { token, new_password: pw });
      setState("done");
    } catch (err) { setError(errMsg(err)); }
    finally { setBusy(false); }
  };

  return (
    <div className="lynx-login">
      <style>{CSS}</style>
      <div className="scene">
        <div className="topleft">
          <img className="mark" src="/somcore-logo.png" alt="Somcore logo" />
          <h1>Somcore Finance<br />Module</h1>
          <div className="eyebrow">SECURE<span>•</span>ACCURATE<span>•</span>CONNECTED</div>
        </div>

        <div className="bottomleft">
          <h2>Finance as solid as the ground you work</h2>
          <p>Every transaction accounted for.</p>
        </div>

        <div className="stage">
          <div className="card" data-testid="reset-password-page">
            <img className="mark" src="/somcore-logo.png" alt="Somcore logo" />

            {state === "checking" && (
              <>
                <h2>Reset password</h2>
                <p>Checking your reset link…</p>
              </>
            )}

            {state === "invalid" && (
              <>
                <h2>Link expired</h2>
                <p>This reset link is no longer valid.</p>
                <div className="lg-note err" data-testid="reset-invalid">
                  <Warning size={20} weight="fill" />
                  <div className="title">Invalid or expired link</div>
                  <p style={{ margin: 0 }}>Ask Ronick to send you a fresh reset link, then open it within 60 minutes.</p>
                </div>
                <button type="button" className="ghost" onClick={() => navigate("/login")}>Back to sign in</button>
              </>
            )}

            {state === "form" && (
              <form onSubmit={submit}>
                <h2>Set a new password</h2>
                <p>For {info?.name ? `${info.name} · ` : ""}{info?.email}</p>
                {error && <div className="lg-err" data-testid="reset-error">{error}</div>}
                <div className="field">
                  <label htmlFor="pw1">New password</label>
                  <div className="field-shell">
                    <input id="pw1" type={showPw ? "text" : "password"} placeholder="At least 8 characters"
                      autoComplete="new-password" value={pw} data-testid="reset-pw1" onChange={(e) => setPw(e.target.value)} required />
                    <button type="button" className="toggle-pw" data-testid="toggle-password"
                      onClick={() => setShowPw((v) => !v)}>{showPw ? "hide" : "show"}</button>
                  </div>
                </div>
                <div className="field">
                  <label htmlFor="pw2">Confirm new password</label>
                  <div className="field-shell">
                    <input id="pw2" type={showPw ? "text" : "password"} placeholder="Re-enter your password"
                      autoComplete="new-password" value={pw2} data-testid="reset-pw2" onChange={(e) => setPw2(e.target.value)} required />
                  </div>
                </div>
                <button type="submit" className="submit" disabled={busy} data-testid="reset-submit">
                  {busy ? "Saving…" : "Set password"}
                </button>
              </form>
            )}

            {state === "done" && (
              <>
                <h2>All set</h2>
                <p>Your password has been updated.</p>
                <div className="lg-note ok" data-testid="reset-done">
                  <CheckCircle size={22} weight="fill" />
                  <div className="title">Password updated</div>
                  <p style={{ margin: 0 }}>You can now sign in with your new password.</p>
                </div>
                <button type="button" className="submit" data-testid="reset-goto-login" onClick={() => navigate("/login")}>Go to sign in</button>
              </>
            )}

            <div className="authorized">Authorized access only</div>
          </div>
        </div>
      </div>
    </div>
  );
}
